module.exports = __webpack_public_path__ + "img/android.e732acea.png";